module.exports = __webpack_public_path__ + "static/media/m-operator-img-004.333dbf47.jpg";